import { useEffect, useState } from 'react'

interface ICheckboxProps {
	onChange?: Function
	className?: string
	checked?: boolean
	label?: any
	labelClassName?: string
	labelStyle?: Object
	beforeLabel?: any
	beforeLabelClassName?: string
	beforeLabelStyle?: Object
	type?: 'checkbox' | 'toggle'
	useValueForChecked?: boolean
	value?: any
	[key: string]: any
}

const Checkbox = (props: ICheckboxProps) => {
	const {
		onChange = null,
		className = '',
		label = '',
		labelClassName = '',
		labelStyle = {},
		beforeLabel = '',
		beforeLabelClassName = '',
		beforeLabelStyle = {},
		type = 'checkbox',
		useValueForChecked = null,
		value = '',
		returnChecked = false,
		...rest
	} = props

	const [checked, setChecked] = useState(
		useValueForChecked ? Boolean(value) : props.checked ?? false
	)

	useEffect(() => {
		setChecked(useValueForChecked ? Boolean(value) : props.checked ?? false)
	}, [props.checked])

	const changeState = (event) => {
		setChecked(!checked)
		if (onChange) {
			onChange(event, !checked)
		}
	}

	const defaultIcon = (
		<span
			className="inline-block  border-purple-700 transform rotate-45 scale-75 w-3 h-5 self-center"
			style={{ margin: '-1px 0 0 6px', borderWidth: '0 4px 4px 0' }}
		></span>
	)

	var settings = {
		toggleHtml: null,
		labelClass: 'flex-none border h-6 w-6 rounded ',
		inputClass: 'hidden',
		role: 'checkbox',
		checkedIcon: checked ? defaultIcon : '',
	}

	if (type == 'toggle') {
		settings.labelClass = 'inline-flex items-center cursor-pointer '
		settings.inputClass = `hidden`
		settings.role = 'switch'
		settings.toggleHtml = (
			<>
				<div
					className={`rounded-full inline-flex w-10 h-6 bg-gray-200 transition-all duration-300 ${
						checked ? 'bg-purple-700' : ''
					}`}
				>
					<div
						className={`w-4 h-4 rounded-full bg-white m-1 shadow-sm transition-all duration-300 ${
							checked ? 'ml-5' : ''
						}`}
					></div>
				</div>
			</>
		)
		settings.checkedIcon = ''
	}

	return (
		<div className="checkbox-wrapper flex">
			{beforeLabel != '' && (
				<label
					className={beforeLabelClassName}
					style={beforeLabelStyle}
					htmlFor={rest?.id}
				>
					{beforeLabel}
				</label>
			)}

			<label
				className={
					settings.labelClass +
					className.replace('w-full', '') +
					(checked ? '' : '')
				}
				htmlFor={rest?.id}
			>
				<input
					className={settings.inputClass}
					type="checkbox"
					checked={checked}
					role={settings.role}
					value={value}
					{...rest}
					// do onchange afterwards
					onChange={changeState}
				/>
				{settings.toggleHtml}
				{settings.checkedIcon}
			</label>
			<label className={labelClassName} style={labelStyle} htmlFor={rest?.id}>
				{label}
			</label>
		</div>
	)
}
Checkbox.isFormable = true

export default Checkbox
